import { classnames } from '@aibees/shared/utils';
import { Avatar, Box, Typography } from '@mui/material';
import { memo } from 'react';
import { Icon } from '../icon';
import * as Styled from './styles';
import * as SX from './sx';
import type { DialogTitleProps as Props } from './types';

export const DialogTitle = memo(
  ({
    className,
    title,
    avatar,
    icon,
    closeIconColor,
    closeIconSize,
    iconColor,
    iconSize,
    onBack,
    onClose,
  }: Props) => {
    return (
      <Styled.Wrapper
        className={classnames('DialogTitle', className)}
        sx={SX.root}
      >
        <Box alignItems="center" display="flex" gap={0.5}>
          {avatar ? (
            <Avatar src={avatar} size={24} />
          ) : (
            icon && (
              <Icon
                name={icon}
                size={iconSize || 22}
                sxx={SX.icon(!!onBack)}
                color={iconColor || 'primary.500'}
                onClick={onBack}
              />
            )
          )}

          <Typography variant="body2" fontWeight={400} color="grey.800">
            {title}
          </Typography>
        </Box>

        {onClose && (
          <Icon
            name="close"
            onClick={onClose}
            size={closeIconSize || 16}
            sxx={SX.closeIcon}
            color={closeIconColor || 'grey.700'}
          />
        )}
      </Styled.Wrapper>
    );
  }
);

DialogTitle.displayName = 'DialogTitle';
